export class LoginRequest {
    token: string;

    constructor(sessionId: string) {
        this.token = sessionId;
    }
}